import React from 'react';
import { PLAN } from '../../data/content';
import SectionHeader from '../SectionHeader';
import { useIntersection } from '../../hooks/useIntersection';

const BL = '#1565C0';
const G2 = '#2F9E5C';

export default function Plan() {
  const { ref, visible } = useIntersection();
  return (
    <section id="plan" style={{ padding: '72px 0', borderBottom: '1px solid #D1D5DB', background: 'var(--gray-lt)' }}>
      <div className="r25-section-wrap" style={{ maxWidth: 'var(--max)', margin: '0 auto', padding: '0 40px' }}>
        <SectionHeader num={PLAN.sectionNum} title={PLAN.title} titleEm={PLAN.titleEm} body={PLAN.body} />
        <div ref={ref} className={`fade-in${visible ? ' visible' : ''}`}>

          <div className="r25-table-wrap">
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14, borderRadius: 8, overflow: 'hidden', boxShadow: '0 1px 8px rgba(0,0,0,0.05)', marginBottom: 32 }}>
              <thead>
                <tr>
                  {['Revenue Stream', '2025 Actual', '2026 Target'].map((h, i) => (
                    <th key={h} style={{ background: '#06410A', color: '#fff', padding: '12px 16px', fontWeight: 600, fontSize: 12, textAlign: i === 0 ? 'left' : 'center' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {PLAN.revenue.map((row, i) => (
                  <tr key={i}>
                    <td style={{ padding: '11px 16px', borderBottom: '1px solid #D1D5DB', color: 'var(--ink)', background: i % 2 === 0 ? '#fff' : 'var(--gray-lt)' }}>{row.stream}</td>
                    <td style={{ padding: '11px 16px', borderBottom: '1px solid #D1D5DB', color: 'var(--gray)', textAlign: 'center', background: i % 2 === 0 ? '#fff' : 'var(--gray-lt)' }}>{row.y2025}</td>
                    <td style={{ padding: '11px 16px', borderBottom: '1px solid #D1D5DB', color: BL, fontWeight: 600, textAlign: 'center', background: i % 2 === 0 ? '#fff' : 'var(--gray-lt)' }}>{row.y2026}</td>
                  </tr>
                ))}
                <tr>
                  <td style={{ padding: '12px 16px', background: 'var(--gpale)', fontWeight: 700, color: 'var(--ink)' }}>{PLAN.total.stream}</td>
                  <td style={{ padding: '12px 16px', background: 'var(--gpale)', color: 'var(--gray)', textAlign: 'center' }}>{PLAN.total.y2025}</td>
                  <td style={{ padding: '12px 16px', background: 'var(--gpale)', color: G2, fontWeight: 700, textAlign: 'center' }}>{PLAN.total.y2026}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h3 style={{ fontFamily: 'var(--serif)', fontSize: 20, color: 'var(--ink)', marginBottom: 16, fontWeight: 600 }}>Key milestones</h3>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {PLAN.milestones.map((m, i) => (
              <div key={i} className="r25-milestone-row" style={{
                display: 'flex', gap: 20, alignItems: 'flex-start',
                padding: '18px 0',
                borderBottom: i < PLAN.milestones.length - 1 ? '1px solid #D1D5DB' : 'none',
              }}>
                <div className="r25-milestone-when" style={{ fontSize: 12, fontWeight: 600, color: G2, letterSpacing: 0.5, minWidth: 90, paddingTop: 2 }}>{m.when}</div>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--ink)', marginBottom: 3 }}>{m.title}</div>
                  <div style={{ fontSize: 13, color: 'var(--gray)', lineHeight: 1.6 }}>{m.body}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
